import { render, staticRenderFns } from "./AcoesCancelar.vue?vue&type=template&id=38650805&scoped=true"
import script from "./AcoesCancelar.vue?vue&type=script&lang=js"
export * from "./AcoesCancelar.vue?vue&type=script&lang=js"
import style0 from "./AcoesCancelar.vue?vue&type=style&index=0&id=38650805&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38650805",
  null
  
)

export default component.exports